module.exports = __webpack_public_path__ + "img/photos-icon.12a410b2.svg";